import { CenteredLayout } from '../employer_onboarding/CenteredLayout'

export function ManagedByThatchPage () {
  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading='Verifying your Business'
        subheading='The verification process for your business is currently being managed by the Thatch team. If you have any questions or need assistance, please reach out to us at support@thatch.com.'
        align='center'
      />
    </CenteredLayout>
  )
}
